<template>
  <div class="add">
    <ul>
      <li @click="handleClick('Heading')">
        <span class="material-symbols-outlined">format_h1</span>{{ $t('AddList.Heading') }}
      </li>
      <li @click="handleClick('Text')">
        <span class="material-symbols-outlined">text_fields</span>{{ $t('AddList.Text') }}
      </li>
      <li @click="handleClick('Button')">
        <span class="material-symbols-outlined">buttons_alt</span>{{ $t('AddList.Button') }}
      </li>
      <li @click="handleClick('Image')">
        <span class="material-symbols-outlined">image</span>{{ $t('AddList.Image') }}
      </li>
      <li @click="handleClick('Spacer')">
        <span class="material-symbols-outlined">rectangle</span>{{ $t('AddList.Spacer') }}
      </li>
      <li @click="handleClick('Divider')">
        <span class="material-symbols-outlined">horizontal_rule</span>{{ $t('AddList.Divider') }}
      </li>
      <li @click="handleClick('Container')">
        <span class="material-symbols-outlined">add_to_photos</span>{{ $t('AddList.Container') }}
      </li>
      <li @click="handleClick('ColumnsContainer')">
        <span class="material-symbols-outlined">splitscreen_vertical_add</span>{{ $t('AddList.Column') }}
      </li>
      <li @click="handleClick('Html')">
        <span class="material-symbols-outlined">html</span>{{ $t('AddList.Html') }}
      </li>
      <!-- <li @click="handleClick('Qr')">
        <span class="material-symbols-outlined">qr_code_2</span>QR Code
      </li> -->
     <li @click="handleClick('DynContainer')">
        <span class="material-symbols-outlined">dynamic_form</span>{{ $t('AddList.Dynamic') }}
      </li>  
      <li @click="handleClick('Ruleset')">
        <span class="material-symbols-outlined">rule</span>{{ $t('AddList.Ruleset') }}
      </li>
      <li @click="handleClick('Database')" >
        <span class="material-symbols-outlined">database</span>{{ $t('AddList.Database') }}
      </li>
      <li v-if="parentRoot || parentEmpty == 'root'" @click="handleClick('Boilerplate')">
        <span class="material-symbols-outlined">folder</span>{{ $t('AddList.Boilerplate') }}
      </li>
      <li @click="pasteFromClipboard()" :class="{ noCopyLi: !copyClipboard}">
        <span class="material-symbols-outlined" :class="{ noCopy: !copyClipboard}">content_paste_go</span>Paste
      </li>
    </ul>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  props: {
    position: {
      type: String,
      required: false,
    },
    parentId: {
      type: String,
      required: false,
    },
    clicked: {
      type: String,
      required: true,
    },
    parentRoot:{
      type: Boolean,
      required: false,
    },
    parentEmpty: {
      type: String,
      required: false,
    },
    parentType: {
      type: String,
      required: true,
    },
    parentLevel: {
      type: String,
      required: false,
    },
    blockId: {
      type: String,
      required: false,
    },
    index: {
      type: Number,
      default: null,
      required: false,
    }
  },
  computed: {
    ...mapState(['copyClipboard']),
  },
  methods: {
    ...mapActions(['addNewBlockFromClipboard', 'updateActiveTab', 'updateAddState', 'addNewBlock', 'updatePositionBoiler', 'updateParentBoiler', 'updateCopyCliboard']),
    handleClick(item) {
      this.updateActiveTab ('Inspect')
      this.updateAddState(item);
      if (item == "Boilerplate" || item == "Database"){
        this.updatePositionBoiler(this.position);
        this.updateParentBoiler(this.parentId);
        console.log(this.parentId, this.position )
        this.$emit('closePopUp');
        if (this.parentEmpty == 'root')
          this.$emit('closeAdd');
      }else {
      switch(this.clicked){
      case "empty": 
      this.$emit('add-blockE', item, this.position);
      //this.addNewBlock(item);
      break;
      case "component": 
      this.$emit('add-blockC', item, this.position);
      //this.addNewBlock(item);
      break;
      case "container":
      this.$emit('add-blockCo', item);
      } 
      }
    },
    pasteFromClipboard(){
      console.log(this.copyClipboard.type == 'Text')
     this.addNewBlockFromClipboard({
        targetId: this.parentId,
        position: this.position,
        parentId: this.blockId ,
        parentType: this.parentType,
        placeholderIndex: this.index
      });
      console.log(this.parentId, this.position, this.blockId, this.parentType, this.index)
      /* this.updateActiveTab ('Inspect')
      this.updateAddState(this.copyClipboard.type);
      this.addNewBlock({
        type: type,
        targetId: this.activeComponentId,
        position,
        parentId: 'root',
        parentType: 'root'
      }); */
    }
  }
};
</script>

<style scoped>
.add {
  width: 300px;
  background: white;
  color: black ;
  z-index: 15;
  position: absolute;
  border: 1px solid;
  padding: 10px;
  font-family: "Montserrat", sans-serif;
}

ul {
  width: 100%;
  list-style-type: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: start;
}

li {
  font-size: 12px;
  width: 24%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 15px;
  cursor: pointer;
  padding-top: 5px;
}

li:hover {
  background-color: #f0f0f0; 
} 

.material-symbols-outlined {
  background:  var(--secondary-color);
  color: white;
  font-size: 35px;
  padding: 3px 5px;
  margin: 0px;
  margin-bottom: 5px;
}

.noCopy {
  background:  darkgray !important;
  opacity: 0.8;
}

.noCopyLi:hover {
  background-color: transparent !important;
  cursor: not-allowed;

} 
</style>

